import React, { useContext, useEffect, useRef, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { CiCamera, CiCircleCheck } from "react-icons/ci";
import { FaEdit, FaLock } from "react-icons/fa";
import { IoLogOutOutline } from "react-icons/io5";
import { PiWarningCircleLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../App";
import ClientAuthContext from "../../context/ClientAuthContext";
import data1 from "../../data/data.json";
import options from "../../data/options.json";
import { serverInstance } from "../../service/axios";
import { handleApiError } from "../../utils/ErrorMessageUtils";
import { isEmpty } from "../../utils/Utils";
import ChangePassword from "./ChangePassword";
import "./client.scss";

const ClientPage = ({ data }) => {
  const { language } = useContext(ThemeContext);
  const [state, setState] = useState(true);
  const fileInputRef = useRef(null);
  const orgFileInputRef = useRef(null);
  const bucket = "lingo-portal-assets";
  const region = "ap-northeast-2";
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(ClientAuthContext);
  
  const getLangCode = () => {
    if (language === "en" || language === "ko" || language === "jp" || language === "de" || language === "se") return "en";
    return "mn";
  };
  const [unsavedUser, setUnsavedUser] = useState({
    first_name: "",
    last_name: "",
    position: "",
    image_url: "",
  });
  const [mobile_number, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [unsavedOrg, setUnsavedOrg] = useState({
    id: "",
    name: "",
    name_en: "",
    address_state: "",
    address_state_en: "",
    address_town: "",
    address_town_en: "",
    address_line_1: "",
    address_line_1_en: "",
    address_line_2: "",
    address_line_2_en: "",
    position: "",
    number_of_english_teachers: 0,
    number_of_students: 0,
    logo_url: "",
    web_link: "",
    social_link: "",
    map_link: "",
  });
  const [originalOrg, setOriginalOrg] = useState({
    id: "",
    name: "",
    name_en: "",
    address_state: "",
    address_state_en: "",
    address_town: "",
    address_town_en: "",
    address_line_1: "",
    address_line_1_en: "",
    address_line_2: "",
    address_line_2_en: "",
    position: "",
    number_of_english_teachers: 0,
    number_of_students: 0,
    logo_url: "",
    web_link: "",
    social_link: "",
    map_link: "",
  });
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [orgFile, setOrgFile] = useState(null);
  const [orgUploading, setOrgUploading] = useState(false);
  const [orgUploaded, setOrgUploaded] = useState(false);
  const [userSuccessMsg, setUserSuccessMsg] = useState("");
  const [userErrorMsg, setUserErrorMsg] = useState("");
  const [orgSuccessMsg, setOrgSuccessMsg] = useState("");
  const [orgErrorMsg, setOrgErrorMsg] = useState("");
  const [loading, setLoading] = useState(true); // Initial loading
  const [userLoading, setUserLoading] = useState(false); // User data operations
  const [orgLoading, setOrgLoading] = useState(false); // Organization data operations
  const [fileName, setFileName] = useState("");
  const [orgFileName, setOrgFileName] = useState("");
  const [filePreviewUrl, setFilePreviewUrl] = useState("");
  const [orgFilePreviewUrl, setOrgFilePreviewUrl] = useState("");
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [editEmail, setEditEmail] = useState("");
  const [editMobile, setEditMobile] = useState("");
  const [modalError, setModalError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [currentEditType, setCurrentEditType] = useState(""); // "email" or "mobile"
  const [orgLanguageTab, setOrgLanguageTab] = useState("mn"); // "mn" or "en"
  const [optionsData, setOptionsData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("lingoPortalToken");
    if (token) {
      serverInstance
        .get(
          "/school/client",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          setUserData(res.data.user);
          setUnsavedUser({
            first_name: res.data.user.first_name,
            last_name: res.data.user.last_name,
            position: res.data.user.position,
            image_url: res.data.user.image_url,
          });
          setUnsavedOrg(res.data.org);
          setOriginalOrg(res.data.org);
          setMobileNumber(res.data.user.mobile_number);
          setEmail(res.data.user.email);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    if (orgLanguageTab && options[orgLanguageTab]) {
      setOptionsData(options[orgLanguageTab]);
    }
  }, [orgLanguageTab, options]);

  useEffect(() => {
    if (!file) {
      setFilePreviewUrl("");
      return;
    }
    const url = URL.createObjectURL(file);
    setFilePreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  useEffect(() => {
    if (!orgFile) {
      setOrgFilePreviewUrl("");
      return;
    }
    const url = URL.createObjectURL(orgFile);
    setOrgFilePreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [orgFile]);

  const getUploadUrl = async () => {
    try {
      let response = await serverInstance.post(
        "/school/upload",
        { key: unsavedUser.image_url },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("lingoPortalToken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        let uploadUrl = response.data.uploadUrl;
        return uploadUrl;
      }
      return undefined;
    } catch (err) {
      console.error(err);
      return undefined;
    }
  };

  const getOrgUploadUrl = async () => {
    try {
      let response = await serverInstance.post(
        "/school/upload",
        { key: unsavedOrg.logo_url },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("lingoPortalToken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        let uploadUrl = response.data.uploadUrl;
        return uploadUrl;
      }
      return undefined;
    } catch (err) {
      console.error(err);
      return undefined;
    }
  };

  const uploadFile = async (uploadUrl) => {
    try {
      let fileBlob = new Blob([file], { type: file.type });
      let response = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          ContentType: file.type,
        },
        body: fileBlob,
      });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const uploadOrgFile = async (uploadUrl) => {
    try {
      let fileBlob = new Blob([orgFile], { type: orgFile.type });
      let response = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          ContentType: orgFile.type,
        },
        body: fileBlob,
      });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const deleteOldImage = async (key) => {
    try {
      await serverInstance.delete("/school/upload", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("lingoPortalToken")}`,
          "Content-Type": "application/json",
        },
        data: { key: key },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const validateUserData = () => {
    if (!unsavedUser.first_name.trim()) {
      setUserErrorMsg(data.first_name_required);
      return false;
    }
    if (!unsavedUser.last_name.trim()) {
      setUserErrorMsg(data.last_name_required);
      return false;
    }
    if (!unsavedUser.position.trim()) {
      setUserErrorMsg(data.position_required);
      return false;
    }
    return true;
  };

  const hasUserDataChanged = () => {
    return (
      userData.first_name !== unsavedUser.first_name ||
      userData.last_name !== unsavedUser.last_name ||
      userData.position !== unsavedUser.position ||
      userData.image_url !== unsavedUser.image_url ||
      file !== null // Account for new file selected but not yet uploaded
    );
  };

  const hasOrgDataChanged = () => {
    return (
      originalOrg.name !== unsavedOrg.name ||
      originalOrg.name_en !== unsavedOrg.name_en ||
      originalOrg.address_state !== unsavedOrg.address_state ||
      originalOrg.address_state_en !== unsavedOrg.address_state_en ||
      originalOrg.address_town !== unsavedOrg.address_town ||
      originalOrg.address_town_en !== unsavedOrg.address_town_en ||
      originalOrg.address_line_1 !== unsavedOrg.address_line_1 ||
      originalOrg.address_line_1_en !== unsavedOrg.address_line_1_en ||
      originalOrg.address_line_2 !== unsavedOrg.address_line_2 ||
      originalOrg.address_line_2_en !== unsavedOrg.address_line_2_en ||
      originalOrg.position !== unsavedOrg.position ||
      originalOrg.number_of_english_teachers !== unsavedOrg.number_of_english_teachers ||
      originalOrg.number_of_students !== unsavedOrg.number_of_students ||
      originalOrg.logo_url !== unsavedOrg.logo_url ||
      originalOrg.web_link !== unsavedOrg.web_link ||
      originalOrg.social_link !== unsavedOrg.social_link ||
      originalOrg.map_link !== unsavedOrg.map_link ||
      orgFile !== null // Account for new organization logo file selected but not yet uploaded
    );
  };

  const saveUserData = async (event) => {
    event.preventDefault();
    if (!validateUserData()) {
      return;
    }

    // Check if there are any changes to save
    if (!hasUserDataChanged()) {
      setUserErrorMsg(data.noChanges || "Өөрчлөлт оруулаагүй байна");
      setUserSuccessMsg("");
      return;
    }

    setUserSuccessMsg("");
    setUserErrorMsg("");
    setUserLoading(true);

    // Upload whenever a new file was chosen (same S3 key / extension still replaces the object)
    if (file && unsavedUser.image_url) {
      let uploadUrl = await getUploadUrl();

      if (isEmpty(uploadUrl)) {
        setUserErrorMsg("Зураг хуулахад үед алдаа гарлаа");
        setUserLoading(false);
        return false;
      }

      let result = await uploadFile(uploadUrl);
      setUploaded(result);

      if (!result) {
        setUserErrorMsg("Зураг хуулахад алдаа гарлаа");
        setUserLoading(false);
        return;
      }
    }

    serverInstance
      .put("/school/client", unsavedUser, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("lingoPortalToken")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let imageToDelete =
          userData.image_url && userData.image_url !== unsavedUser.image_url
            ? userData.image_url
            : null;
        setUserData(unsavedUser);
        setFile(null);
        setFileName("");
        setUserErrorMsg("");
        setUserSuccessMsg("Амжилттай хадгаллаа.");
        setUserLoading(false);
        if (uploading) {
          setUploading(false);
        }
        if (imageToDelete) {
          deleteOldImage(imageToDelete);
        }
      })
      .catch((err) => {
        console.error(err);
        setUserErrorMsg(err?.response?.data?.message || "Хадгалахад алдаа гарлаа");
        setUserLoading(false);
      });
  };

  const saveOrgData = async (event) => {
    event.preventDefault();

    // Check if there are any changes to save
    if (!hasOrgDataChanged()) {
      setOrgErrorMsg(data.noChanges || "Өөрчлөлт оруулаагүй байна");
      setOrgSuccessMsg("");
      return;
    }

    setOrgSuccessMsg("");
    setOrgErrorMsg("");
    setOrgLoading(true);

    // Upload when a local file is pending (same key as before still must be re-uploaded)
    if (orgFile && unsavedOrg.logo_url) {
      let uploadUrl = await getOrgUploadUrl();

      if (isEmpty(uploadUrl)) {
        setOrgErrorMsg("Лого хуулахад үед алдаа гарлаа");
        setOrgLoading(false);
        return false;
      }

      let result = await uploadOrgFile(uploadUrl);
      setOrgUploaded(result);

      if (!result) {
        setOrgErrorMsg("Лого хуулахад алдаа гарлаа");
        setOrgLoading(false);
        return;
      }
    }

    serverInstance
      .put("/school/client/org", unsavedOrg, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("lingoPortalToken")}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let logoToDelete =
          originalOrg.logo_url && originalOrg.logo_url !== unsavedOrg.logo_url
            ? originalOrg.logo_url
            : null;
        setOriginalOrg(unsavedOrg); // Update original data after successful save
        setOrgFile(null);
        setOrgFileName("");
        setOrgErrorMsg("");
        setOrgSuccessMsg("Амжилттай хадгаллаа.");
        setOrgLoading(false);
        if (orgUploading) {
          setOrgUploading(false);
        }
        if (logoToDelete) {
          deleteOldImage(logoToDelete);
        }
      })
      .catch((err) => {
        console.error(err);
        setOrgErrorMsg(err?.response?.data?.message || "Хадгалахад алдаа гарлаа");
        setOrgLoading(false);
      });
  };

  const generateFileKeyInS3 = (file_name) => {
    let fileExt = file_name.split(".").pop();
    return `teacher/${userData.id}.${fileExt}`;
  };

  const generateOrgLogoKeyInS3 = (file_name) => {
    let fileExt = file_name.split(".").pop();
    return `school/${originalOrg.id}.${fileExt}`;
  };

  const fileChanges = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile?.name || "");
    setUnsavedUser({
      ...unsavedUser,
      image_url: generateFileKeyInS3(selectedFile.name),
    });
  };

  const orgFileChanges = (e) => {
    const selectedFile = e.target.files[0];
    setOrgFile(selectedFile);
    setOrgFileName(selectedFile?.name || "");
    setUnsavedOrg({
      ...unsavedOrg,
      logo_url: generateOrgLogoKeyInS3(selectedFile.name),
    });
  };

  const logout = () => {
    localStorage.removeItem("lingoPortalToken");
    setUserData({});
    navigate("/");
  };

  // Open email edit modal
  const openEmailModal = () => {
    setEditEmail(email);
    setModalError("");
    setOtpSent(false);
    setOtpCode("");
    setCurrentEditType("email");
    setShowEmailModal(true);
  };

  // Open mobile edit modal
  const openMobileModal = () => {
    setEditMobile(mobile_number);
    setModalError("");
    setOtpSent(false);
    setOtpCode("");
    setCurrentEditType("mobile");
    setShowMobileModal(true);
  };

  // Check if email is already registered
  const checkEmailRegistration = async (newEmail) => {
    if (newEmail === email) {
      return true; // No change, skip check
    }

    try {
      const response = await serverInstance.post("/school/email-registered", {
        email: newEmail.toLowerCase()
      });

      if (response.status === 200) {
        if (response.data.message === "REGISTERED") {
          setModalError(data.email_already_registered || "Энэ Мэйл хаяг аль хэдийн бүртгэгдсэн байна");
          return false;
        } else {
          return true; // Email is available
        }
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      setModalError(handleApiError(data, errorMessage));
      return false;
    }
    return false;
  };

  // Check if mobile number is already registered
  const checkMobileRegistration = async (newMobile) => {
    if (newMobile === mobile_number) {
      return true; // No change, skip check
    }

    try {
      const response = await serverInstance.post("/school/mobile-registered", {
        mobile_ext: "+976",
        mobile_number: newMobile
      });

      if (response.status === 200) {
        if (response.data.message === "REGISTERED") {
          setModalError(data.mobile_already_registered || "Энэ утасны дугаар аль хэдийн бүртгэгдсэн байна");
          return false;
        } else {
          return true; // Mobile number is available
        }
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      setModalError(handleApiError(data, errorMessage));
      return false;
    }
    return false;
  };

  // Send OTP for verification
  const sendOTP = async () => {
    if (currentEditType === "email") {
      if (!editEmail.trim()) {
        setModalError(data.email_required || "Мэйл хаяг оруулна уу");
        return;
      }

      if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(editEmail)) {
        setModalError(data.invalid_email || "Мэйл хаяг буруу байна");
        return;
      }

      const isEmailAvailable = await checkEmailRegistration(editEmail);
      if (!isEmailAvailable) {
        return;
      }
    } else if (currentEditType === "mobile") {
      if (!editMobile.trim()) {
        setModalError(data.mobile_number_required || "Утасны дугаар оруулна уу");
        return;
      }

      const mobilePattern = /^[0-9]{8}$/;
      if (!mobilePattern.test(editMobile)) {
        setModalError(data.invalid_mobile || "Утасны дугаар буруу байна");
        return;
      }

      const isMobileAvailable = await checkMobileRegistration(editMobile);
      if (!isMobileAvailable) {
        return;
      }
    }

    setOtpLoading(true);
    setModalError("");

    try {
      const endpoint = currentEditType === "email" ? "/email/send" : "/sms/send";
      const requestData = currentEditType === "email"
        ? {
          email: editEmail.toLowerCase(),
          lang: getLangCode()
        }
        : {
          mobile_ext: "+976",
          mobile_number: editMobile,
          lang: getLangCode()
        };

      const response = await serverInstance.post(endpoint, requestData);

      if (response.status === 200) {
        setOtpSent(true);
        setModalError("");
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      setModalError(handleApiError(data, errorMessage));
    } finally {
      setOtpLoading(false);
    }
  };

  // Verify OTP and save changes
  const verifyOTPAndSave = async () => {
    if (!otpCode.trim()) {
      setModalError(data.enterOTP || "Баталгаажуулах кодыг оруулна уу");
      return;
    }

    setOtpLoading(true);
    setModalError("");

    try {
      // Send OTP code directly in the PUT request to /school/client
      const updateData = currentEditType === "email"
        ? {
          email: editEmail.toLowerCase(),
          code: otpCode,
          lang: getLangCode()
        }
        : {
          mobile_ext: "+976",
          mobile_number: editMobile,
          code: otpCode,
          lang: getLangCode()
        };

      const updateResponse = await serverInstance.put("/school/client", updateData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("lingoPortalToken")}`,
          "Content-Type": "application/json",
        },
      });

      if (updateResponse.status === 200) {
        if (currentEditType === "email") {
          setEmail(editEmail);
          setUserData({ ...userData, email: editEmail });
          setShowEmailModal(false);
          setUserSuccessMsg(data.emailUpdated || "Мэйл хаяг амжилттай шинэчлэгдлээ");
        } else {
          setMobileNumber(editMobile);
          setUserData({ ...userData, mobile_number: editMobile });
          setShowMobileModal(false);
          setUserSuccessMsg(data.mobileUpdated || "Утасны дугаар амжилттай шинэчлэгдлээ");
        }
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message;
      setModalError(handleApiError(data, errorMessage, "Өөрчлөхөд алдаа гарлаа"));
    } finally {
      setOtpLoading(false);
    }
  };

  // Save email changes (now triggers OTP flow)
  const saveEmail = async () => {
    // Check if email has actually changed
    if (editEmail === email) {
      setModalError(data.emailNotChanged || "Мэйл хаяг өөрчлөгдөөгүй байна");
      return;
    }

    setCurrentEditType("email");
    await sendOTP();
  };

  // Save mobile number changes (now triggers OTP flow)
  const saveMobile = async () => {
    // Check if mobile number has actually changed
    if (editMobile === mobile_number) {
      setModalError(data.mobileNotChanged || "Утасны дугаар өөрчлөгдөөгүй байна");
      return;
    }

    setCurrentEditType("mobile");
    await sendOTP();
  };

  if (loading) {
    return (
      <div className="client-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <div style={{ textAlign: 'center' }}>
          <AiOutlineLoading3Quarters size={40} className="loading-spinner" style={{ animation: 'spin 1s linear infinite' }} />
        </div>
      </div>
    );
  }

  return (
    <div className="client-container">
      <div className="container1">
        <div className="row-flex" onClick={() => setState(true)}>
          <div className="pro-contnr">
            <BsFillPersonFill size={40} />
          </div>
          <h4>{data.title}</h4>
        </div>
        <div className="row-flex" onClick={() => setState(false)}>
          <div className="pro-contnr">
            <FaLock size={35} />
          </div>
          <h4>{data.changePassword}</h4>
        </div>
        <div className="row-flex" onClick={logout}>
          <div className="pro-contnr">
            <IoLogOutOutline size={35} />
          </div>
          <h4>{data.logout}</h4>
        </div>
        {/* <Link to="/membership" className="row-flex">
          <div className="pro-contnr">
            <CiCreditCard1 size={35} />
          </div>
          <h4>{data.membership}</h4>
        </Link> */}
      </div>
      {state ? (
        <div className="container2">

          <h3>{data.title2}</h3>
          <div className="flex-wrap">
            {userData?.image_url && !uploading ? (
              <div className="section-row">
                <div className="flex-row">
                  <div className="profile-pic" style={{ position: "relative" }}>
                    <img
                      src={`https://${bucket}.s3.${region}.amazonaws.com/${unsavedUser.image_url}`}
                      alt="User profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                    <div
                      className="cameraContainer"
                      onClick={() => setUploading(true)}
                    >
                      <CiCamera color="white" size={20} />
                    </div>
                  </div>
                  <h3>{userData?.first_name}</h3>
                </div>
                
              </div>
            ) : null}

            {!userData?.image_url || uploading ? (
              <div className="section-row">
                <div className="flex-row">
                  <div
                    className="profile-pic"
                    style={{ position: "relative" }}
                  >
                    {filePreviewUrl || userData?.image_url ? (
                      <img
                        src={
                          filePreviewUrl ||
                          `https://${bucket}.s3.${region}.amazonaws.com/${unsavedUser.image_url}`
                        }
                        alt="Selected profile preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    ) : null}
                    <div
                      className="cameraContainer"
                      onClick={() => fileInputRef.current?.click()}
                    >
                      <CiCamera color="white" size={20} />
                    </div>
                  </div>
                  <h3>{unsavedUser?.first_name}</h3>
                </div>
                <input
                  type="file"
                  name="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={(e) => fileChanges(e)}
                  style={{ display: "none" }}
                />
                {fileName ? (
                  <p style={{ fontSize: "12px", textWrap: "wrap" }}>
                    Сонгосон файл: {fileName}
                  </p>
                ) : null}
                {userData?.image_url && uploading ? (
                  <span
                    className="recover-file"
                    onClick={() => setUploading(false)}
                  >
                    Файл сэргээх
                  </span>
                ) : null}
              </div>
            ) : null}
            <div className="line" />
            <div className="section-row">
              <label>{data.last_name}</label>
              <input
                type="text"
                name="last_name"
                required
                value={unsavedUser?.last_name}
                onChange={(e) =>
                  setUnsavedUser({ ...unsavedUser, last_name: e.target.value })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.first_name}</label>
              <input
                type="text"
                name="first_name"
                required
                value={unsavedUser?.first_name}
                onChange={(e) =>
                  setUnsavedUser({ ...unsavedUser, first_name: e.target.value })
                }
              />
            </div>
            <div className="section-row">
              <label>{data.job_position}</label>
              <select
                name="position"
                value={unsavedUser?.position}
                onChange={(e) =>
                  setUnsavedUser({ ...unsavedUser, position: e.target.value })
                }
                required
                className="sign-select"
              >
                {optionsData?.positions?.map((el, i) => (
                  <option key={i} value={el.position}>
                    {el.position}
                  </option>
                ))}
              </select>
            </div>
            <div className="section-row">
              <label>{data.email}</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  name="email"
                  className="disabled"
                  disabled
                  value={email}
                  style={{ width: '100%', paddingRight: '40px' }}
                />
                <FaEdit
                  onClick={openEmailModal}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#007bff',
                    zIndex: 1
                  }}
                  title="Edit email"
                />
              </div>
            </div>
            <div className="section-row">
              <label>{data.mobile_number}</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  name="mobile_number"
                  disabled
                  className="disabled"
                  value={mobile_number}
                  style={{ width: '100%', paddingRight: '40px' }}
                />
                <FaEdit
                  onClick={openMobileModal}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#007bff',
                    zIndex: 1
                  }}
                  title="Edit mobile number"
                />
              </div>
            </div>
          </div>

          {/* User Data Save Button */}
          <div className="section-row" style={{ alignSelf: "start" }}>
            <button type="submit" disabled={userLoading} onClick={saveUserData}>
              {userLoading ? (data.saving || "Хадгалж байна...") : data.save}
            </button>
          </div>

          {/* User Data Messages */}
          {userErrorMsg ? (
            <div className="section-row error">
              <PiWarningCircleLight />
              &nbsp;
              {userErrorMsg}
            </div>
          ) : null}
          {userSuccessMsg ? (
            <div className="section-row success-msg">
              <CiCircleCheck />
              &nbsp;
              {userSuccessMsg}
            </div>
          ) : null}

          <h3>{data.title3}</h3>
          <div className="flex-wrap">
            {/* Organization Logo Section — use originalOrg + orgFile so local preview shows before S3 upload */}
            {originalOrg?.logo_url && !orgUploading && !orgFile ? (
              <div className="section-row">
                <div className="flex-row">
                  <div className="profile-pic" style={{ position: "relative" }}>
                    <img
                      src={`https://${bucket}.s3.${region}.amazonaws.com/${originalOrg.logo_url}`}
                      alt="Organization logo"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                    <div
                      className="cameraContainer"
                      onClick={() => setOrgUploading(true)}
                    >
                      <CiCamera color="white" size={20} />
                    </div>
                  </div>
                  <h3>{unsavedOrg?.name}</h3>
                </div>
              
              </div>
            ) : null}

            {!originalOrg?.logo_url || orgUploading || orgFile ? (
              <div className="section-row">
                <div className="flex-row">
                  <div
                    className="profile-pic"
                    style={{ position: "relative" }}
                  >
                    {orgFilePreviewUrl || originalOrg?.logo_url ? (
                      <img
                        src={
                          orgFilePreviewUrl ||
                          `https://${bucket}.s3.${region}.amazonaws.com/${originalOrg.logo_url}`
                        }
                        alt="Selected organization logo preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    ) : null}
                    <div
                      className="cameraContainer"
                      onClick={() => orgFileInputRef.current?.click()}
                    >
                      <CiCamera color="white" size={20} />
                    </div>
                  </div>
                  <h3>{unsavedOrg?.name}</h3>
                </div>
                <input
                  type="file"
                  name="orgFile"
                  accept="image/*"
                  ref={orgFileInputRef}
                  onChange={(e) => orgFileChanges(e)}
                  style={{ display: "none" }}
                />
                {orgFileName ? (
                  <p style={{ fontSize: "12px", textWrap: "wrap" }}>
                    Сонгосон файл: {orgFileName}
                  </p>
                ) : null}
                {(originalOrg?.logo_url || orgFile) && orgUploading ? (
                  <span
                    className="recover-file"
                    onClick={() => {
                      setOrgUploading(false);
                      setOrgFile(null);
                      setOrgFileName("");
                      setUnsavedOrg({
                        ...unsavedOrg,
                        logo_url: originalOrg.logo_url,
                      });
                    }}
                  >
                    Файл сэргээх
                  </span>
                ) : null}
              </div>
            ) : null}

            {/* Organization Language Tabs */}
            <div className="section-row">
              <div className="org-language-tabs">
                <button
                  type="button"
                  onClick={() => setOrgLanguageTab("mn")}
                  className={`tab-button ${orgLanguageTab === "mn" ? "active" : ""}`}
                >
                  Монгол
                </button>
                <button
                  type="button"
                  onClick={() => setOrgLanguageTab("en")}
                  className={`tab-button ${orgLanguageTab === "en" ? "active" : ""}`}
                >
                  English
                </button>
              </div>
            </div>

            <div className="section-row">
              <label>{data.org_name} {orgLanguageTab === "en" ? "(English)" : "(Монгол)"}</label>
              <input
                type="text"
                name={orgLanguageTab === "en" ? "name_en" : "name"}
                required
                value={orgLanguageTab === "en" ? unsavedOrg?.name_en : unsavedOrg?.name}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    [orgLanguageTab === "en" ? "name_en" : "name"]: e.target.value,
                  })
                }
              />
            </div>
            {/* Address State */}
            <div className="section-row">
              <label>{data.address_state} {orgLanguageTab === "en" ? "(English)" : "(Монгол)"}</label>
              <select
                name={orgLanguageTab === "en" ? "address_state_en" : "address_state"}
                value={orgLanguageTab === "en" ? unsavedOrg?.address_state_en : unsavedOrg?.address_state}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    [orgLanguageTab === "en" ? "address_state_en" : "address_state"]: e.target.value,
                  })
                }
                required
                className="sign-select"
              >
                {optionsData?.regions?.map((el, i) => (
                  <option key={i} value={el.name}>
                    {el.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Address Town */}
            <div className="section-row">
              <label>{data.address_town} {orgLanguageTab === "en" ? "(English)" : "(Монгол)"}</label>
              <input
                type="text"
                name={orgLanguageTab === "en" ? "address_town_en" : "address_town"}
                required
                value={orgLanguageTab === "en" ? unsavedOrg?.address_town_en : unsavedOrg?.address_town}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    [orgLanguageTab === "en" ? "address_town_en" : "address_town"]: e.target.value,
                  })
                }
              />
            </div>

            {/* Address Line 2 */}
            <div className="section-row">
              <label>{data.address_line_2} {orgLanguageTab === "en" ? "(English)" : "(Монгол)"}</label>
              <input
                type="text"
                name={orgLanguageTab === "en" ? "address_line_2_en" : "address_line_2"}
                required
                value={orgLanguageTab === "en" ? unsavedOrg?.address_line_2_en : unsavedOrg?.address_line_2}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    [orgLanguageTab === "en" ? "address_line_2_en" : "address_line_2"]: e.target.value,
                  })
                }
              />
            </div>

            {/* Address Line 1 */}
            <div className="section-row">
              <label>{data.address_line_1} {orgLanguageTab === "en" ? "(English)" : "(Монгол)"}</label>
              <input
                type="text"
                name={orgLanguageTab === "en" ? "address_line_1_en" : "address_line_1"}
                required
                value={orgLanguageTab === "en" ? unsavedOrg?.address_line_1_en : unsavedOrg?.address_line_1}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    [orgLanguageTab === "en" ? "address_line_1_en" : "address_line_1"]: e.target.value,
                  })
                }
              />
            </div>

            {/* Number of English Teachers */}
            <div className="section-row">
              <label>{data.englishTeachers}</label>
              <select
                name="number_of_english_teachers"
                value={unsavedOrg?.number_of_english_teachers}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    number_of_english_teachers: parseInt(e.target.value) || 0,
                  })
                }
                className="sign-select"
              >
                {optionsData?.numTeachers?.map((el, i) => (
                  <option key={i} value={el.value}>
                    {el.text}
                  </option>
                ))}
              </select>
            </div>

            {/* Number of Students */}
            <div className="section-row">
              <label>{data.totalStudents}</label>
              <select
                name="number_of_students"
                value={unsavedOrg?.number_of_students}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    number_of_students: parseInt(e.target.value) || 0,
                  })
                }
                className="sign-select"
              >
                {optionsData?.numStudents?.map((el, i) => (
                  <option key={i} value={el.value}>
                    {el.text}
                  </option>
                ))}
              </select>
            </div>

            {/* Web Link */}
            <div className="section-row">
              <label>{data.websiteUrl}</label>
              <input
                type="url"
                name="web_link"
                value={unsavedOrg?.web_link}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    web_link: e.target.value,
                  })
                }
                placeholder="https://example.com"
              />
            </div>

            {/* Social Link */}
            <div className="section-row">
              <label>{data.socialMediaLink}</label>
              <input
                type="url"
                name="social_link"
                value={unsavedOrg?.social_link}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    social_link: e.target.value,
                  })
                }
                placeholder="https://facebook.com/example"
              />
            </div>

            {/* Map Link */}
            <div className="section-row">
              <label>{data.googleMapsLink}</label>
              <input
                type="url"
                name="map_link"
                value={unsavedOrg?.map_link}
                onChange={(e) =>
                  setUnsavedOrg({
                    ...unsavedOrg,
                    map_link: e.target.value,
                  })
                }
                placeholder="https://maps.google.com/..."
              />
            </div>
          </div>

          {/* Organization Data Save Button */}
          <div className="section-row" style={{ alignSelf: "start" }}>
            <button type="submit" disabled={orgLoading} onClick={saveOrgData}>
              {orgLoading ? (data.saving || "Хадгалж байна...") : data.save}
            </button>
          </div>

          {/* Organization Data Messages */}
          {orgErrorMsg ? (
            <div className="section-row error">
              <PiWarningCircleLight />
              &nbsp;
              {orgErrorMsg}
            </div>
          ) : null}
          {orgSuccessMsg ? (
            <div className="section-row success-msg">
              <CiCircleCheck />
              &nbsp;
              {orgSuccessMsg}
            </div>
          ) : null}
        </div>
      ) : (
        <div className="container2">
          <ChangePassword
            data={
              language === "en" ? data1.English.SignUp :
              language === "ko" ? data1.Korean.SignUp :
              language === "jp" ? data1.Japanese.SignUp :
              language === "de" ? data1.German.SignUp :
              language === "se" ? data1.Swedish.SignUp :
              data1.Mongolian.SignUp
            }
          />
        </div>
      )}

      {/* Email Edit Modal */}
      {showEmailModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '500px',
            maxWidth: '90vw'
          }}>
            <h3>{data.editEmail || "Edit Email"}</h3>

            {!otpSent ? (
              <>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>{data.email}:</label>
                  <input
                    type="email"
                    value={editEmail}
                    onChange={(e) => setEditEmail(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px'
                    }}
                    placeholder={data.enterEmail || "Enter email address"}
                  />
                </div>
                {modalError && (
                  <div style={{ color: 'red', marginBottom: '15px', fontSize: '14px' }}>
                    <PiWarningCircleLight /> {modalError}
                  </div>
                )}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => setShowEmailModal(false)}
                    disabled={otpLoading}
                    style={{
                      padding: '8px 16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    {data.cancel || "Cancel"}
                  </button>
                  <button
                    onClick={saveEmail}
                    disabled={otpLoading || editEmail === email}
                    style={{
                      padding: '8px 16px',
                      border: 'none',
                      borderRadius: '4px',
                      backgroundColor: (otpLoading || editEmail === email) ? '#ccc' : '#007bff',
                      color: 'white',
                      cursor: (otpLoading || editEmail === email) ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {otpLoading ? (data.sending || "Sending...") : (data.sendOTP || "Send OTP")}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{ marginBottom: '15px' }}>
                  <p style={{ marginBottom: '10px' }}>
                    {data.otpSent || "OTP sent to"}: {editEmail}
                  </p>
                  <label style={{ display: 'block', marginBottom: '5px' }}>{data.enterOTP || "Enter OTP"}:</label>
                  <input
                    type="text"
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px'
                    }}
                    placeholder="6 оронтой код оруулна уу"
                    maxLength={6}
                  />
                </div>
                {modalError && (
                  <div style={{ color: 'red', marginBottom: '15px', fontSize: '14px' }}>
                    <PiWarningCircleLight /> {modalError}
                  </div>
                )}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => {
                      setOtpSent(false);
                      setOtpCode("");
                      setModalError("");
                    }}
                    disabled={otpLoading}
                    style={{
                      padding: '8px 16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    {data.back || "Back"}
                  </button>
                  <button
                    onClick={verifyOTPAndSave}
                    disabled={otpLoading}
                    style={{
                      padding: '8px 16px',
                      border: 'none',
                      borderRadius: '4px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      cursor: otpLoading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {otpLoading ? (data.verifying || "Verifying...") : (data.verifyOTP || "Verify & Save")}
                  </button>
                </div>
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                  <button
                    onClick={sendOTP}
                    disabled={otpLoading}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#007bff',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                  >
                    {data.resendOTP || "Resend OTP"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Mobile Number Edit Modal */}
      {showMobileModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            width: '500px',
            maxWidth: '90vw'
          }}>
            <h3>{data.editMobile || "Edit Mobile Number"}</h3>

            {!otpSent ? (
              <>
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ display: 'block', marginBottom: '5px' }}>{data.mobile_number}:</label>
                  <input
                    type="tel"
                    value={editMobile}
                    onChange={(e) => setEditMobile(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px'
                    }}
                    placeholder={data.enterMobile || "Enter 8-digit mobile number"}
                    maxLength={8}
                  />
                </div>
                {modalError && (
                  <div style={{ color: 'red', marginBottom: '15px', fontSize: '14px' }}>
                    <PiWarningCircleLight /> {modalError}
                  </div>
                )}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => setShowMobileModal(false)}
                    disabled={otpLoading}
                    style={{
                      padding: '8px 16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    {data.cancel || "Cancel"}
                  </button>
                  <button
                    onClick={saveMobile}
                    disabled={otpLoading || editMobile === mobile_number}
                    style={{
                      padding: '8px 16px',
                      border: 'none',
                      borderRadius: '4px',
                      backgroundColor: (otpLoading || editMobile === mobile_number) ? '#ccc' : '#007bff',
                      color: 'white',
                      cursor: (otpLoading || editMobile === mobile_number) ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {otpLoading ? (data.sending || "Sending...") : (data.sendOTP || "Send OTP")}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{ marginBottom: '15px' }}>
                  <p style={{ marginBottom: '10px' }}>
                    {data.otpSent || "OTP sent to"}: {editMobile}
                  </p>
                  <label style={{ display: 'block', marginBottom: '5px' }}>{data.enterOTP || "Enter OTP"}:</label>
                  <input
                    type="text"
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px'
                    }}
                    placeholder="6 оронтой код оруулна уу"
                    maxLength={6}
                  />
                </div>
                {modalError && (
                  <div style={{ color: 'red', marginBottom: '15px', fontSize: '14px' }}>
                    <PiWarningCircleLight /> {modalError}
                  </div>
                )}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => {
                      setOtpSent(false);
                      setOtpCode("");
                      setModalError("");
                    }}
                    disabled={otpLoading}
                    style={{
                      padding: '8px 16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    {data.back || "Back"}
                  </button>
                  <button
                    onClick={verifyOTPAndSave}
                    disabled={otpLoading}
                    style={{
                      padding: '8px 16px',
                      border: 'none',
                      borderRadius: '4px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      cursor: otpLoading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {otpLoading ? (data.verifying || "Verifying...") : (data.verifyOTP || "Verify & Save")}
                  </button>
                </div>
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                  <button
                    onClick={sendOTP}
                    disabled={otpLoading}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#007bff',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                  >
                    {data.resendOTP || "Resend OTP"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientPage;
